<template>
  <div class="px-3">
    <div class="text-center">
      تنظیم پیامک برای نقش های موجود در <span class="text-warning">{{ Data.LevelName }}</span>
    </div>
    <div class="mt-4 form-control" v-for="(item, key) in Data.tblUserRols" :key="key">
      <div class="row">
        <div class="col-md-6 col-12 text-center">{{ item.tblUserRoleName }}</div>
        <div class="col-md-6 col-12 text-center">
          <div class="custom-control custom-switch">
            <small id="LbltblComboGrpId50" class="ml-2">پیامک ارسال شود</small>
            <input type="checkbox" class="custom-control-input required InputText" :id="'Done' + item.Id" v-model="item.SendSms" />
            <label class="custom-control-label" :for="'Done' + item.Id"> </label>
            <small class="mr-5"> نشود </small>
          </div>
        </div>
      </div>
    </div>
    <div class="float-left mt-3">
      <Button class="btn btn-success" @click="SetSmsSeting"><i class="fad fa-check ml-2"></i> اعمال تغیرات </Button>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {}
  },
  props: ['Department', 'Data'],
  methods:{
    SetSmsSeting(){
        console.log("😎 ~ SetSmsSeting ~ data:", this.Data.tblUserRols)
        let DataAxios_SetData = {
        ArryfildValue: {},
        Method: 'post',
        Action: 'Workflow/SetSmsSeting',
        Token: this.$session.get('Token'),
      }

      DataAxios_SetData.ArryfildValue = this.Data.tblUserRols
      this.$PostData(DataAxios_SetData)
        .then((data) => {
          if (data.status == 'Ok') {
            this.$toasted.success('پیامک ها با موفقیت تنظیم گردید', { duration: 5000 })
           
            // this.DataAxios = { FormAutomation: null, FormAutomationName: '', LevelName: '', users: [] }
          }
        })
        .finally(() => {})
    }
  },
  created(){
    console.log(this.Data);
    console.log(this.Department);
  }
}
</script>
<style scoped></style>
